import React, { memo } from 'react'
import { AnimatePresence } from 'framer-motion'
import { AppNavigation } from '../styles/headerStyles'

import { useRecoilValue } from 'recoil'
import { currentSection as currentSectionState } from '../store/uiStore'

import useWindowResize from '../hooks/useWindowResize'

import Dots from '../components/Navigation/Dots'
import MenuButton from '../components/Navigation/MenuButton'
import NextButton from '../components/Navigation/NextButton'
import SideMenu from '../components/Navigation/SideMenu'

const Header = () => {

  const windowSize = useWindowResize()
  const currentSection = useRecoilValue(currentSectionState)
  const headerVars = {
    hidden: {
      opacity: 0,
      x: '100%',
    },
    visible: {
      opacity: 1,
      x: 0,
    },
  }
  return (
    <AnimatePresence>
      {!['intro', 'servicio', 'miembro'].includes(currentSection) && (
        <AppNavigation
          initial='hidden'
          animate='visible'
          exit='hidden'
          variants={headerVars}
          transition={{
            duration: 1.5,
            ease: 'easeOut',
          }}
          className={currentSection}>
          <MenuButton />
          {windowSize.width > 420 && (
            <Dots />
          )}
          <NextButton />
          <SideMenu />
        </AppNavigation>
      )}
    </AnimatePresence>
  )
}

export default memo(Header)
